import script from "./tool-tip.vue?vue&type=script&setup=true&lang=ts"
export * from "./tool-tip.vue?vue&type=script&setup=true&lang=ts"

import "./tool-tip.vue?vue&type=style&index=0&id=0cd96ef7&lang=scss"

const __exports__ = script;

export default __exports__